/** Иконка файла из макета: тёмно-синий лист с загнутым уголком.
 *  При `accent` — зелёный (выбранный файл). */
export function FileGlyph({
  className,
  accent = false,
}: {
  className?: string;
  accent?: boolean;
}) {
  return (
    <svg viewBox="0 0 40 48" className={className} aria-hidden>
      <path
        d="M6 2h20l8 8v34a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
        fill={accent ? '#34B58A' : '#1b2a4e'}
      />
      <path d="M26 2v8h8z" fill="#3a4a6f" />
    </svg>
  );
}
